export default {
    data() {
      return {
        isMobile: false,
        sideNavOpen: false,
        scrollPos: 0,
      };
    },
    mounted() {
      this.checkMobile();
      window.addEventListener("resize", this.handleResize);
      document.addEventListener("mouseup", this.handleClickOutside);
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.handleResize);
      document.removeEventListener("mouseup", this.handleClickOutside);
    },
    methods: {
      checkMobile() {
        this.isMobile = /android|iphone|ipad|ipod|windows phone/i.test(navigator.userAgent);
      },
      handleResize() {
        if (!this.isMobile) this.closeSideNav();
      },
      toggleSideNav() {
        if (!this.sideNavOpen) {
          this.scrollPos = window.scrollY;
          document.body.classList.add("offcanvas-menu");
        } else {
          document.body.classList.remove("offcanvas-menu");
          window.scrollTo(0, this.scrollPos);
        }
        this.sideNavOpen = !this.sideNavOpen;
      },
      closeSideNav() {
        if (this.sideNavOpen) {
          document.body.classList.remove("offcanvas-menu");
          window.scrollTo(0, this.scrollPos);
          this.sideNavOpen = false;
        }
      },
      openSideDropdown(event) {
        const target = event.currentTarget;
        const allItems = document.querySelectorAll(".side-nav > li[role='none']");
        const closeButton = document.querySelector(".close-dropdown-view");

        target.classList.add("open-dropdown-view");

        closeButton.classList.remove("hide");

        allItems.forEach((item) => {
          if (item !== target) item.classList.add("hide");
        });
      },
      closeSideDropdown() {
        document.querySelectorAll(".side-nav > li").forEach((el) => {
          el.classList.remove("open-dropdown-view", "hide", "open");
          el.querySelector(".dropdown-toggle").setAttribute("aria-expanded", "false");
        });
        document.querySelector(".close-dropdown-view").classList.add("hide");
      },
      handleClickOutside(event) {
        if (this.sideNavOpen) {
          const nav = document.querySelector(".click-through-mobile-nav-bar");
          if (!nav.contains(event.target)) {
            this.closeSideNav();
          }
        }
      },
      addOpen: function (e) {
        e.target.classList.add("open");
      },
      removeOpen: function (e) {
        e.target.classList.remove("open");
      },
    },
  };
  